import { Component, ComponentRef, DoCheck, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { TableSwitch } from "../switch-table/switch-table.component";
import { ModalService } from "../../services/modal.service";
import { Subscription } from "rxjs";

@Component({
	selector: "app-switch-table-with-dialog",
	templateUrl: "./switch-table-with-dialog.component.html",
	styleUrls: ["./switch-table-with-dialog.component.scss"],
})
export class SwitchTableWithDialogComponent implements OnInit, OnDestroy, OnChanges, DoCheck {
	@Input() onName = "";
	@Input() offName = "";
	@Input() onHeader = "";
	@Input() offHeader = "";
	@Input() onDescription = "";
	@Input() offDescription = "";
	@Input() onButtonText = "";
	@Input() offButtonText = "";
	@Input() disabledTooltip = "";
	@Input() isDisabled = false;
	@Input() item!: TableSwitch;
	@Output() itemChange: EventEmitter<TableSwitch> = new EventEmitter<TableSwitch>();

	isOpenDialog = false;

	header = "";
	description = "";
	buttonText = "";

	subs: Subscription[] = [];

	constructor(private modalService: ModalService) {}

	ngOnInit() {
		this.initSubscribe();
		this.setContentConfirmDialog();
	}

	ngOnDestroy() {
		this.subs.forEach((item) => item.unsubscribe());
	}

	ngOnChanges(changes: SimpleChanges): void {}

	ngDoCheck() {}

	initSubscribe() {
		this.subs.push(
			this.modalService.isModalOpen$.subscribe({
				next: (res) => (this.isOpenDialog = res),
			})
		);
	}

	changeState() {
		if (!this.isDisabled) {
			this.item.state = !this.item.state;
		}

		this.itemChange.emit(this.item);
		this.setContentConfirmDialog();
	}

	openModal() {
		if (!this.isDisabled) {
			this.isOpenDialog = true;
		}
	}

	setContentConfirmDialog() {
		if (this.item.state) {
			this.header = this.offHeader;
			this.description = this.offDescription;
			this.buttonText = this.offButtonText;
		} else {
			this.header = this.onHeader;
			this.description = this.onDescription;
			this.buttonText = this.onButtonText;
		}
	}
}
